module.exports = __webpack_public_path__ + "media/images/icons/chevron-left-icon-12270ee677c5b5bc9939a0fc2bf002a5.svg";